import {
    FETCH_BUDGET_REPORT,
} from '../types';
import api from '../api';

export const fetchBudgetReport = (data) => {
    return {
        type: FETCH_BUDGET_REPORT,
        payload: api.reports.budget(data),
    };
};
